<template>

  <div class="page_container">
      <div class="content_container">
 <div class="update_time">更新日期：2025 年 02 月 13 日</div>

<p>安卓版“净信背单词”由郑州麟宁网络科技有限公司运营。 以下的“净信”和“我们”指代运营对应版本的“净信背单词”的主体。</p>

<p>欢迎您选择净信提供的产品与服务！我们将通过《隐私政策》（以下简称“本政策”）向您细化说明您在使用本产品与服务时我们收集、使用、存储和共享个人信息的情况，以及您所拥有的版权的相关权利等事项。我们采用多方位的安全保护措施，以确保对您的个人信息保护处于合理的安全水平。</p>

<div class="first_title">一、我们收集信息的目的以及如何收集信息</div>
<p>在您使用净信的产品与服务的过程中，净信会按照以下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，可以向您提供，优化我们的服务以及保障您的账户安全：</p>

<div class="second_title">1、我们通过以下途径收集和获得您的个人信息：</div>
<p>（1）在注册净信背单词单词服务的帐号或使用净信背单词服务时，向我们提供的个人信息，包括您的手机号码，并且您可以自愿选择填写您的昵称、头像基本信息。</p>

<p>（2）在注册完成后，您可以选择修改或补充您的头像，昵称等信息（但不提供这些信息且不会影响您使用净信的产品或服务）。对于该等账号信息所涉的个人信息，净信将按照本《隐私政策》予以保护。</p>

<p>（3）您购买净信提供的收费产品等服务时，以便帮助您顺利完成交易，保障您的交易安全，查询订单信息等，在您下单交易或为了完成交易时，我们会收集您的交易商品/服务信息，订单号，交易金额，支付方式等信息。</p>

<p>（4）在您使用净信产品或服务时，您可能会因账号管理，产品使用等问题联系净信客服。 因此，您可能需要向净信提供姓名，手机号码，手机充值记录，身份证照片，身份证号码，购买记录，支付记录，系统操作记录，照片，银行账号，第三方支付平台的账号，与净信进行联系的通信记录及内容等与您使用净信产品或服务相关的信息。 如果您拒绝提供相关信息，净信可能无法帮助您解决相关问题。</p>

<div class="second_title">2、我们会出于以下目的，收集和使用您以下类型的个人信息：</div>
<p>2.1 注册、登录及注销</p>
<p>为使用我们的产品或服务，您首先需要注册账号并登录。您可以选择通过第三方账号或者手机号码验证的方式创建净信背单词的账号并登录。</p>

<p>（1） 如果您选择手机号码验证的方式，您需向我们提供您的手机号码。我们收集这一信息是为了识别和验证您的身份。手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。</p>

<p>（2） 如果您选择第三方账户登录，我们可能从第三方获取您授权共享的账户信息 （头像、昵称、登录时间）井在您同意本协议后将您的第三方账户与您的净信背单词服务账户绑定，使您可以通过第三方账户直接登录井使用我们的服务。在您登录后，您可能仍然需要向我们补充提供您的手机号码，以完善您的账号信息并满足相关法律法规的网络实名制要求。</p>

<p>（3） 如果您不再使用我们服务，在符合服务协议约定条件及国家相关法律法规规定的情况下，我们也提供注册账号的注销，您可以通过本协议【注销账号】约定的联系方式或具体指引进行操作。</p>

<p>2.2 客服与售后</p>
<p>依照相关法律法规规定及监管要求，或当您与我们联系时，我们的客服或售后可能会需要您提供真实身份信息（姓名、身份证）和账号信息以核验您的身份，以便帮助您问题，或记录相关问题的处理方案及结果。</p>

<p>请注意，您的身份信息属于个人敏感信息，请您谨慎提供，如果拒绝提供您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。</p>

<p>2.3 向您提供商品或服务</p>
<p>（1）个人信息的分享与发布：您在使用净信背单词服务时、上传和/或发布个人信息以及进行相关行为时（例如：您在活动页面留言、提交意见反馈、提交商品/服务评价等），我们将收集您上传、发布或形成的个人信息，并有杈展示您的昵称、头像和发布内容。</p>

<p>（2） 商品或服务交付：您购买我们提供的收费产品及服务时、为了履行您与我们签署的协议向您提供我们的课程讲解、督学群运营等服务，您可能需要向我们提供您的手机号、微信号。为了帮助您顺利完成交易、保障您的交易安全、查询订单信息等，在您下单交易或为了完成交易时，我们会收集您的交易商品/服务信息、订单号、交易金额、支付方式、支付时问、支付渠道的信息。</p>

<p>（3） 客服与售后服务：在您使用我们产品或服务时，您可能会因账号管理、产品使用等问题联系我们客服。为此，您可能需要向我们提供手机号码、购买记录、支付记录、系统操作记录、与我们进行联系的通信记录及内容等与您使用我们产品或服务相关的信息，以便我们的客服人员与您联系，并帮您解决相关问题；</p>

<p>（4） 单词及课程学习：为了帮助您实现单词及课程学习功能，我们将收集您学习过程中产生的单词学习信息、生词本、熟知次、收藏信息、单词笔记、词书选择信息、打卡及备份信息;</p>

<p>（5） 活动分享及互动：在您分享或接收被分享的信息、参加活动等情形下，净信背单词客户端需要在本地访问您设备的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。客户端仅在本地识别出剪切板内容属于净信跳转、分享、活动联动等指令时才会将其上传我们的服务器。除此之外，净信背单词客户端不会上传剪切板的其他信息至我们的服务器。在您使用我们服务过程中，为识别账号异常状态，保护您账号安全、了解产品适配性，维护基础功能的正常运行，我们会收集您使用净信背单词服务的相关操作信息，这些信息包括：</p>

<p>2.4 维护基础功能的正常运行</p>
<p>在您使用我们服务过程中，为识别账号异常状态，保护您账号安全、了解产品适配性，维护基础功能的正常运行，我们会收集您使用净信背单词服务的相关操作信息，这些信息包括：</p>

<p>（1） 日志信息：当您使用我们的服务时，我们可能会收集您对我们服务的详细使用情況，作为有关网络日志保存。日志信息包括您的登录账号、搜索查询内容、词书选择记录、学习记录、IP 地址、浏览器的类型、电信运营商、网络环境、访问日期和时间、崩溃记录、停留时长、收藏及分享。</p>

<p>（2） 设备信息：包括硬件型号、操作系统版本号、设备标识符（IMEl、Android_ ID、OAID、ISI、MEID、OpenUDID、IDFV、IDFA、UUID）网络设备硬件地址（MAC 地址）、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth） 、WiFi、软件版本号、设备分辨率、网络接入方式、类型、状态、网络质量。如您不同意我们记录或收集前述信息，可能无法完成风控验证，导致您无法使用净信背单词服务。</p>

<p>2.5 其他</p>
<p>您了解井同意，在收集您的个人信息后，我们可能通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用己经去标识化的信息，对用户数据库进行分析并子以商业化的利用，而无需另行获得您的同意。</p>

<p>请您注意，如果我们要将您的个人信息用于本协议中未载明的其他用途或额外收集未提及的其他个人信息，我们会另行事先请您同意（确认同意的方式：勾选、弹窗、站内信、邮件、短信方式）。一旦您同意，该等额外用途将视为本协议的一部分，该等额外个人信息也将适用本协议。</p>

<p>2.6 征得授权同意的例外</p>
<p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授杈同意：</p>

<p>（1）与个人信息控制者履行法律法规规定的义务相关的；</p>

<p>（2）与国家安全、国防安全直接相关的；</p>

<p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>

<p>（4）与刑事侦查、起诉、审判和判決执行等直接相关的；</p>

<p>（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>

<p>（6）所涉及的个人信息是个人信息主体自行向社会公众公开的；</p>

<p>（7）根据个人信息主体要求签订和履行合同所必需的；</p>

<p>（8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>

<p>（9）维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障。</p>

<p>2.7 您理解并同意，净信背单词服务可能需要您在您的设备中开启特定的系统权限（比如：摄像头、相册、外置存储、麦克风、日历等），以实现这些权限所涉及个人信息的收集和使用。</p>
<p>当您需要关闭上诉功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</p>

<p>2.8 有关个人敏感信息的提示</p>
<p>以上由您提供或我们收集您的个人信息中，可能包含您的个人敏感信息，包括订单记录、虛拟财产信息、系统账号、邮箱地址及其有关的密码、电话号码、浏览记录。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本协议所述的目的和方式来处理。</p>

<div class="second_title">3、净信收集您所使用的相关设备及网络信息</div>
<p>为了更好地向您提供产品或服务，净信可能使用多个自动数据收集工具，包括 Cookie 和内嵌 Web 跟踪链接。净信不会将上述技术用于本政策所述目的以外的任何用途。请您理解，净信的某些服务只能通过使用上述技术如您的设备或相关程序允许，您可以通过更改设置或通过访问提供商的网页等合适的方式，来关闭或删除上述技术。但这一举动可能会影响您使用净信产品或服务。</p>

<p>当您使用净信的产品或服务时，净信将收集您所使用的相关设备信息，以便为您提供持续稳定的服务支持（如数据的实时同步等），同时有助于净信不断改善自身产品或服务，从而使您在使用净信的产品或服务过程中获得最优体验。净信收集的您所使用的相关设备信息包括设备名称、设备型号、操作系统和已安装应用列表及应用程序版本及类型、语言设置、 移动终端随机存储内存、登录 IP 地址、接入网络的方式、网络质量数据、移动网络信息（包括运营商名称）、日志信息（如服务日志）等等。</p>

<div class="second_title">4、通过调用设备权限向您收集的信息</div>
<p>（1）为提升净信产品或服务的使用体验和便利程度，净信可能会通过调用设备权限的方式收集您的个人信息。 如果您不同意提供这些个人信息，您可能无法使用与提升用户体验相关的功能，您也可能需要在使用净信产品或服务过程中手动重复填写一些信息。</p>

<p>（2）若您希望向净信上传您的头像或其他图片信息，您可以选择授权净信调用您所使用设备中的摄像头或者相册权限。</p>

<p>（3）若您希望快速便捷地通过第三方移动运营商完成支付，在您的设备支持的情况下，您可以选择授权调用您所使用设备中的移动运营相关权限，以便您快速便捷地完成付款。</p>

<p>（4）若您希望实现或体验上述功能，您可能需要在您的设备中向净信开启您的相应访问权限。您也可以随时选择关闭相应访问权限以取消相应授权。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方的说明或指引。</p>

<p>（5）为使用净信产品或服务的需要， 净信可能会在相关产品或服务中（如排行榜、参与讨论、留言）显示您的个人信息（如性别、头像、昵称）以供其他用户查看。</p>

<p>（6）为学术研究、应用研究的需要，净信可能采集您提供的生日、性别、地区、个人介绍等资料和信息，但净信承诺此类研究中会做去标识化或作匿名化处理。</p>

<p>（7）为向您推荐合适的产品或服务和履行双方间签订的协议，净信将采集您的个人上网记录，包括：您在使用净信产品或服务中的产生的浏览记录、使用记录、点击记录、学习数据等。</p>

<div class="second_title">5、有关第三方服务的特别说明</div>
<p>您可以通过向净信付款的方式获取净信产品或服务，上述付款服务可能由净信以外的第三方提供，净信并不会获取与您付款相关的密码等信息。 但可能从您或第三方支付平台获得您的第三方支付账户（支付宝账号等）。 若您希望了解第三方服务提供商收集个人信息的具体规则，请查阅您选择的第三方付款服务提供商的隐私政策。</p>

<p>净信背单词服务可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：</p>

<p>（1）我们通过我们服务的其他方式向您提供链接，如自定义词典，使您可以链接至第三方的服务或网站；</p>

<p>（2）其他接入第三方服务的情形。为实现本协议中声明的目的，我们可能会接入第三方服务商提供的 SDK 或其他类似的应用程序，并将我们依照本协议收集的您的某些信息共享给该等第三方服务商，以便提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：</p>

<p>a. 用于支付相关服务，包括订单支付、交易行为核验、收入结算、支付信息汇总统计等，如苹果支付、微信支付及支付宝支付；</p>

<p>b. 用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息等；</p>

<p>c. 用于第三方授权服务，包括第三方帐号登陆、将有关内容分享至第三方产品等；</p>

<p>d. 用于支持产品功能模块，包括内容存储、安全加固等，如 360 加固；</p>

<p>我们接入的部分第三方 SDK 或类似应用程序可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。</p>

<p>您也可以选择通过本协议“如何联系我们”所列的反馈渠道联系我们，我们会尽快为您作出解答。</p>

<p>如上所述服务由相关的第三方负责运营。您使用该等第三方服务（包括您向该等第三方提供的任何个人信息），须受第三方自己的服务条款及个人信息保护声明（而非本协议）约束，您需要仔细阅读其条款。我们仅会出于正当、必要、特定的目的共享您的信息。我们会要求他们履行相关保密义务并采取相应的安全措施。</p>

<div class="second_title">6、您充分知晓，在以下情形下，我们收集、使用个人信息无需征得您的授权同意：</div>
<p>（1）与国家安全、国防安全有关的；</p>

<p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>

<p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>

<p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

<p>（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</p>

<p>（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>

<p>（7）根据您要求签订和履行合同所必需的；</p>

<p>（8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>

<p>（9）法律法规规定的其他情形。</p>

<div class="second_title">7、根据法律规定，向第三方提供经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</div>
<div class="first_title">二、我们如何存储和使用收集的信息</div>
<div class="second_title">1、信息的存储</div>
<p>（1）信息存储的方式和期限</p>
<p>我们会通过安全的方式存储您的信息，包括本地存储（例如利用 APP 进行数据缓存）、数据库和服务器日志。</p>

<p>一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。</p>

<p>（2）信息存储的地域</p>

<p>我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>

<div class="second_title">2、我们如何使用信息</div>
<p>我们严格遵守法律法规的规定以及与您的约定，按照本政策及《产品与服务使用协议》所述使用收集的信息，以向您提供更为优质的服务。</p>

<p>（1）信息使用规则</p>

<p>我们会按照如下规则使用收集的信息：</p>

<p>我们会根据我们收集的信息向您提供各项产品与服务，包括基础功能、消费功能等；</p>

<p>a. 我们会根据我们收集的信息向您提供各项产品与服务，包括基础功能、消费功能等；</p>

<p>b. 我们会根据您使用净信产品与服务的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合。</p>

<p>（2）告知变动目的后征得同意的方式</p>

<p>我们将会在本政策所涵盖的用途内使用收集的信息。 如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。</p>

<p>（3）使用产品或服务</p>

<p>需特别说明的是，当您在安卓设备上使用时，为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用自启动或关联启动能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现“学习提醒”功能、保证您在设定的时间准时提醒您所必要的。</p>

<div class="first_title">三、我们如何共享、转让和披露信息</div>
<div class="second_title">1、因业务所需，净信需与关联公司共享用户信息，净信及上述关联公司承诺将善意使用其个人信息，净信将不会向除净信关联公司外的任何其他方公开或共享用户注册资料、设备信息、登陆 IP、搜索及购买记录等个人信息以及存在净信各项服务中的非公开内容，但下列情况除外：</div>
<p>（1）与国家安全、国防安全直接相关的；</p>

<p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>

<p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>

<p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

<p>（5）个人信息主体自行向社会公众公开个人信息的；</p>

<p>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

<p>（7）净信为了维护自己合法权益而向用户提起诉讼或者仲裁时；</p>

<p>（8）应用户监护人的合法要求而提供用户个人身份信息时；</p>

<p>（9）保护净信、关联公司、合作单位的知识产权和其等合法权益；</p>

<p>（10）根据《产品与服务使用协议》等相关规定或者净信认为必要的其他情况。</p>

<div class="second_title">2、为保障净信背单词 App 相关功能的实现与应用安全的稳定运作，我们可能会接入由第三方提供的开发包（SDK）实现相关目的。目前，我们的授权合作方包括以下类型：</div>
  <p>（1）微信OpenSDK Android，开发者:深圳市腾讯计算机系统有限公司。如您使用的终端设备安装了安卓版本的静信背单词 App, 为向您提供微信登陆注册分享支付的功能，微信OpenSDK Android的提供方可能会收集您届时使用设备信息（IMEI/Mac/android ID/ IDFA/OPENU ID/GUID、SIM卡 IMSI 信息）、网络信息等，具体请见<a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">《微信Open SDK个人信息处理规则》</a>；</p>
  
  <p>（2）APP支付客户端SDK，开发者:支付宝(杭州)信息技术有限公司。如您使用的终端设备安装了安卓版本的净信背单词 APP，为向您提供应用内使用支付宝支付的功能，支付宝 SDK 的提供方可能会收集您届时使用设备信息（IMEI/Mac/android ID/ IDFA/OPENU ID/GUID、SIM卡IMSI信息）、网络信息等，具体请见<a href="https://opendocs.alipay.com/open/54/01g6qm#%E6%94%AF%E4%BB%98%E5%AE%9D%20App%20%E6%94%AF%E4%BB%98%E5%AE%A2%E6%88%B7%E7%AB%AF%20SDK%20%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96">《App 支付宝客户端 SDK 隐私说明》</a>;</p>
  
  <p>为了您的信息安全，我们已与合作方 SDK 服务商约定严格的数据安全保密义务，这些公司会严格遵守我们的数据隐私和安全要求。除非得到您的同意，我们不会与其共享您的其他个人信息。</p>

<div class="second_title">3、免责条款除上述规定属免责外，下列情况时净信亦无需承担任何责任：</div>
<p>（1）由于用户将用户账号密码告知他人、用户未保管好自己的密码或与他人共享净信注册账号等，由此导致的任何个人资料泄露；</p>

<p>（2）任何由于黑客攻击、计算机病毒侵入或发作、电信部门技术调整导致的影响、因政府管制而造成的暂时性关闭、 由于第三方原因（包括不可抗力，例如国际出口的主干链路及国际出口电信提供商一方出现故障、火灾、水灾、雷击、地震、洪水、台风、 龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件）及其他非因净信过错而造成的用户个人资料泄露、丢失、 被盗用或被窜改等，以及由此给用户和第三方造成的任何损失；</p>

<p>（3）由于与净信、关联公司链接的其它网站所造成的用户个人资料泄露及由此而导致的任何法律争议和后果；</p>

<p>（4）任何个人用户向净信提供错误、不完整、不实信息等造成不能正常使用净信服务或遭受任何其他损失。 </p>
<div class="first_title">四、如何管理、查看或删除您的个人信息</div>
<p>我们鼓励您更新和修改您的个人信息以使其更准确有效，也请您理解，您更正、删除、撤回授杈或停止使用净信背单词服务的决定，并不影响我们此前基于您的授权而开展的个人信息处理。</p>

<p>您可以通过以下方式来管理您的个人信息：</p>

<div class="second_title">1 访问您的个人信息</div>
<p>账户个人信息：如果您希望访问您的账户中的个人基本信息（包括头像、昵称及第三方账号绑定情况），您可以通过“登录净信背单词 App - 设置 - 帐号”进行访问。</p>

<div class="second_title">2 更正您的个人信息</div>
<p>如果您希望更正您的账户中的个人基本信息（包括头像、昵称、第三方账号绑定关系、邮箱、手机号），您可以通过“登录净信背单词 App - 设置 - 帐号”进行修改。</p>

<div class="second_title">3 删除您的个人信息</div>
<p>您可以通过本政策中列明的方式自主删除您的部分个人信息。在部分个人信息删除时，我们可能会要求您进行身份验证，以保障个人信息安全。</p>

<p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>

<p>（1）如果我们处理个人信息的行为违反法律法规；</p>
<p></p>
<p>（2）如果我们收集、使用您的个人信息，却未征得您的授权同意；</p>
<p></p>
<p>（3）如果我们处理个人信息的行为严重违反了与您的约定；</p>
<p></p>
<p>（4）如果我们不再为您提供净信背单词服务。</p>
<p></p>
<p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
<p></p>
<div class="second_title">4 改变您授权同意的范围</div>
<p>您总是可以选择是否披露个人信息。有些个人信息是使用净信背单词服务所必需的，但大多数其他个人信息的提供是由您决定的。您可以通过本政策中列明的方式删除个人信息、取消第三方授权或注销账号等方式改变您授权我们继续收集个人信息的范围或通过本协议【如何联系我们】约定的联系方式联络我们撤回您的授权，我们将在15个工作日内为您处理。</p>

<p>您可以通过“我 - 设置 - 帐号 - 注销账户”撤回您的授权，当您撒回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的个人信息。但您撤回授权的决定，不会影响此前基子您的授权而开展的个人信息处理。</p>

<div class="second_title">5 注销账号</div>
<p>如果您不再使用净信背单词服务，在符合服务协议约定条件及国家相关法律法规规定的情况下，您可以通过“登录净信背单词 App - 设置 - 更多设置 - 注销账户”所示的流程或本协议【如何联系我们】约定的联系方式联络我们注销您的账号，一般情况下，我们将在 15 个工作日内为您注销账号，届时我们将停止为您提供净信背单词服务。当您的帐号注销或被删除后，与该帐号相关的净信背单词服务项下的全部服务资料和数据将被删除或匿名化处理，但法律法规另有规定的除外。</p>

<div class="second_title">6 获取个人信息副本</div>
<p>根据您的请求，我们可以向您提供我们持有的有关您的个人信息副本（如个人基本资料）。您可以通过本协议【如何联系我们】约定的联系方式向我们提出请求，我们将在收到您的问题之日起 15 个工作日内予以回复。</p>

<div class="second_title">7 约束信息系统自动决策</div>
<p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</p>


<div class="second_title">8 响应您的上述请求</div>
<p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，我们将在必要的身份验证通过后进行处理，最长将在不超过 15 个工作日或法律法规规定期限内作出答复。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或人根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>

<p>在以下情形中，我们将无法响应您的请求：</p>

<p>（1）与我们履行法律法规规定的义务相关的；</p>

<p>（2）与国家安全、国防安全直接相关的；</p>

<p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>

<p>（4）与刑事侦查、起诉、审判和执行判決等直接相关的；</p>

<p>（5）我们有充分证据表明您存在主观恶意或滥用权利的；</p>

<p>（6）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

<p>（7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>

<p>（8）涉及商业秘密的。</p>



<div class="first_title">五、我们如何保护收集的信息</div>
<div class="second_title">1、安全保护措施</div>
<p>（1）我们努力为用户的信息安全提供保障,以防止信息的丢失、不当使用、未经授权访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。</p>

<p>（2）我们采用符合行业标准的安全防护措施来保护您的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我们使用的技术手段包括但不限于防火墙、加密（例如 SSL）、去标识化或匿名化处理、访问控制措施等。我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。</p>

<p>（3）我们建立了保障个人信息安全专门的管理制度、流程和组织。 例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。 我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。</p>

<p>（4）我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。</p>

<p>（5）请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便我们竭尽所能加强安全措施，但也不可能始终保证信息百分之百的绝对安全。 您需要了解和知悉，您接入净信的产品或服务所用的系统和通讯网络，有可能因我们可控范围外的其他因素而出现问题，在此情形下，我们会依法尽力协助解决。</p>

<div class="second_title">2、安全事件处置措施</div>
<p>若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会以公告等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施， 以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。</p>

<div class="first_title">六、注销净信账号</div>
<p>（1）进入净信背单词，登录后进入主页面，点击“设置-更多设置”；</p>

<p>（2）在帐号页面，点击“账号注销”；</p>

<p>注：当您注销账号后，我们将按照《中华人民共和国网络安全法》等法律法规的规定留存您的相关信息；超出法定保存期限后，我们将删除或匿名化处理您的个人信息。</p>

<div class="first_title">七、我们如何处理未成年人的信息</div>
<p>1、我们高度重视未成年人个人信息的保护问题，并持续探索更新未成年人的个人信息保护方式。 如果您是未满 18 周岁的未成年人，应在监护人监护、指导并获得监护人同意情况下仔细阅读本《隐私政策》和使用净信的产品或服务。</p>

<p>2、如果您/您的监护人不同意本《隐私政策》的任何内容，您应该立即停止使用我们的产品或服务。</p>

<p>3、若您是未成年人的监护人，当您对您所监护的未成年人使用我们的产品或服务或其向我们提供的用户信息有任何疑问时， 请您及时与我们联系。我们将根据国家相关法律法规及本政策的规定保护未成年人用户信息的保密性及安全性。 如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>

<div class="first_title">八、本政策如何更新</div>
<p>本隐私政策内容如发生任何实质性变更，我们会在变更生效前通知您并重新获得您的同意，如您不同意变更后的内容，您可以选择停止使用我们的服务； 如您仍然继续使用我们服务的，即表示同意受经修订的《隐私政策》的约束。</p>

<div class="first_title">九、如何联系我们</div>
<p>您在使用我们产品或服务的过程中，如果对本协议有任何的疑义或建议，或您认为您的个人信息没有得到本协议规定的保护，您可以通过以下方式联系我们，我们将在 15 个工作日内真诚地处理您的投诉及建议。</p>

<p>公司名称：郑州麟宁网络科技有限公司</p>

<p>邮寄地址：河南省郑州市金水区丰产路65号附5号2号楼4层155号</p>

<p>意见与反馈邮箱：linningtech2024@163.com</p>

<p>App 内意见反馈渠道：设置 - 更多设置 - 帮助与反馈 - 邮件反馈。</p>

<div class="first_title">十、其他</div>
<p>1、在净信发布本《隐私政策》或向您提供产品或服务均视为本《隐私政策》生效。净信停止运营或永久停止提供产品或服务时本《隐私政策》失效。</p>

<p>2、因本政策以及我们处理您个人信息事宜引起的任何争议，双方应当进行友好协商，协商不一致的，您可诉至郑州市金水区人民法院。</p>

        
        
        
        

      </div>



  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >


 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction:row;
    align-content: left;
    font-size: 0.4rem;
    align-items: left;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    line-height: 1.5;
    
  }

  .update_time{
    color: #999;
    font-size: 0.35rem;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    text-align: left; /* 确保左对齐 */
    
  }
  

  p{
    
    
    color: #333;
    margin: 0;
    padding: 0;
    text-align: left;
    margin-bottom: 0.15rem;
    
  }


  .first_title{
    font-size: 0.5rem;
    color: #333;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    text-align: left; /* 确保左对齐 */
  }

  .second_title{
    
    color: #333;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    text-align: left; /* 确保左对齐 */
  }
  

  

  






  </style>